




























































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { CommonService } from "@/zh-website/src/views/Enterprise/service/CommonService";
@Component({
  components: {
    Banner,
    SideBar
  }
})
export default class AllSuccessCase extends Vue {
  //
  list = {
    style: {
      "background-image": `url(${require("../../../assets/case_banner.jpg")})`,
      height: "493px"
    },
    font1: "他山之石 可以攻玉",
    font2: "使能千行百业数字化人才转型",
    font3: "",
    font4: "",
    font5: "",
    button: ""
  };
  flag = true;
  TabFix = false;
  offsetTop = 700;
  active = 0;
  allClassifyId = 1;
  industryClassifyId = 1;
  allClassifyList = [
    { id: 1, title: "全部" },
    { id: 2, title: "行业人才发展" },
    { id: 3, title: "产品技术培训" },
    { id: 4, title: "数字化领导力" }
  ];
  param = {} as any;
  industryClassifyList: any[] = [];
  successList: any[] = [];
  /* successList = [
    {
      name: "数字政府",
      list: [
        {
          id: 1,
          img:
            "https://www.zj-huawei.com/file/2022-02-11/eC3g77q11DunM3fm6Ds87h8F27l1644574275095.jpg",
          des: "“对标：走进世界一流企业华为”国资委系列研讨班"
        }
      ]
    }
  ];
*/
  mounted() {
    //
    this.getAllClassification(-1);
    this.param = {};
    this.getSuccessCasesList(this.param);
    window.addEventListener("resize", e => {
      //
      if (window.innerWidth <= 768) {
        if (this.allClassifyId != 1 || this.industryClassifyId != 1) {
          this.onChangeList({ id: 1, title: "全部" }, 1);
          //获取数据
        }
      }
    });
  }
  destroyed() {
    window.removeEventListener("resize", e => {
      //
    });
  }
  getAllClassification(index) {
    this.industryClassifyList.push({ id: 1, title: "全部" });
    CommonService.getAllClassification({}).then((res: any) => {
      if (index == -1) {
        res.data.forEach((nav: any) => {
          nav.child.forEach((classification: any) => {
            this.industryClassifyList.push({
              id: classification.id,
              title: classification.name
            });
          });
        });
      } else {
        res.data[index].child.forEach((classification: any) => {
          this.industryClassifyList.push({
            id: classification.id,
            title: classification.name
          });
        });
      }
    });
  }
  _toLink(e) {
    this.$router.push("/enterprise/all-success-case/detail/" + e);
  }
  onChangeList(item, type) {
    this.successList = [];
    this.industryClassifyList = [];
    //置顶
    //判断类型是全部分类的点击还是行业分类的点击
    if (type == 1) {
      //点击了全部分类
      this.allClassifyId = item.id;
      if (this.allClassifyId == 1) this.param = {};
      else this.param = { navigationId: this.allClassifyId - 1 };
      this.industryClassifyId = 1;
    } else {
      //点击了行业分类
      this.industryClassifyId = item.id;
      if (this.industryClassifyId == 1)
        if (this.allClassifyId == 1) this.param = {};
        else
          this.param = {
            navigationId: this.allClassifyId - 1
          };
      else
        this.param = {
          classificationId: this.industryClassifyId
        };
    }
    //请求接口获取数据 重新渲染下方列表
    this.getSuccessCasesList(this.param);
    this.getAllClassification(this.allClassifyId - 2);
  }
  getSuccessCasesList(param) {
    CommonService.getSuccessCasesGroupedList(param).then((res: any) => {
      res.data.forEach((item, index) => {
        this.successList.push({
          name: item.classificationName,
          list: []
        });
        item.cases.forEach(element => {
          this.successList[index].list.push({
            id: element.id,
            img: element.resourceUrl,
            des: element.title
          });
        });
      });
    });
  }
}
